<template>
    <a-entity>
        <a-entity
            v-for="_page in pages"
            v-bind:key="_page.id"
            :data-page="_page.id"
        >
            <info-spot
                :id="'_infospot' + _infospot.id"
                v-for="_infospot in _page.infospots"
                v-bind:key="_infospot.id"
                :scale="page && page.id === _page.id ? '1 1 1':'0 0 0'"
                :infospot="_infospot"
                @infospot-click="onClick()"
            ></info-spot>

        </a-entity>
    </a-entity>
</template>

<script>
import InfoSpot from "./InfoSpot";

export default {
    name: "InfoSpots",
    props: ['pages', 'page'],
    components: {InfoSpot},
    data: function () {
        return {}
    },
    computed: {
    },
    created: function () {
        const me = this;
    },
    methods: {
        onClick() {
        }
    }
}
</script>

<style scoped>
</style>